<template>
  <b-container>
    <h2>Direct uploaden naar docparser</h2>

    <b-overlay 
      :show="busy" 
      variant="dark"
    >
      <b-tabs 
        v-if="parsers" 
        vertical
      >
        <b-tab
          v-for="p in parsers"
          :key="p.id"
          v-model="selectedParser"
          :title="p.label"
          @click="selectedParser = p.id"
        >
          <b-form-row>
            <b-col>
              <b-card-title>Upload voor {{ p.label }}</b-card-title>
              <b-card-sub-title>{{ uploadAPIPath }}</b-card-sub-title>
              <b-form-group 
                v-show="selectedParser != null" 
              >
                <b-input-group 
                  class="my-3"
                  prepend="Keuringsdocument" 
                  style="z-index: 10"
                >
                  <b-file
                    v-model="docparser.upload"
                    accept=".pdf"
                    placeholder="Kies bestand of sleep hier in..."
                    drop-placeholder="Laat maar los..."
                    browse-text="Kies bestand"
                  />
                  <b-input-group-append>
                    <b-button 
                      style="z-index: 100" 
                      @click="uploadDocparser()"
                    >
                      Upload
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-list-group v-if="results.length > 0">
                <b-list-group-item 
                  v-for="(a,index) in results" 
                  :key="index"
                >
                  {{ a.file }}: {{ a.upload.pages }} pagina's, {{ Math.round(a.upload.file_size/1024) }}Kb 
                  <b-badge> {{ a.upload.quota_left }} credits resterend </b-badge>
                </b-list-group-item>
                <b-alert 
                  variant="warning" 
                  show
                >
                  Het kan even duren voordat geuploade documenten zichtbaar zijn in het <b-link
                    :to="{name:'docparser-parsings'}"
                  >
                    docparser overzicht
                  </b-link>.
                </b-alert>
              </b-list-group>
            </b-col>
          </b-form-row>
        </b-tab>
      </b-tabs>
    </b-overlay>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin.js";
export default {
  name: "Parsers",
  components: {},
  mixins: [serviceMixin],
  props: {},
  data() {
    return {
      results: [],
      selectedParser: null,
      busy: false,
      docparser: {
        upload: null,
        isBusy: false,
        docs: [],
        error: null
      },
      parsers: null
    };
  },
  computed: {
    uploadAPIPath: function () {
      return  "/docparser/" + this.selectedParser + "/upload";
    },
  },
  watch: {
    "docparser.upload": function(newval) {
      console.log("newval", newval);
    }
  },
  mounted() {
    this.getParsers();
  },
  methods: {
    getParsers() {
      var vm = this;
      this.busy = true;
      this.get("/docparser/parsers")
        .then(function(response) {
          vm.parsers = response.data;
          // log response headers
          console.log(response.headers);
          
          vm.selectedParser = vm.parsers[0].id;
        })
        .finally(() => (vm.busy = false));
    },
    uploadDocparser() {
      console.log("start upload");
      var vm = this;
      this.busy = true;
      var formdata = new FormData();
      var file_name = this.docparser.upload.name;
      formdata.append("file_content", this.docparser.upload);
      formdata.append("file_name", this.docparser.upload.name);
      this.uploadDocument(this.uploadAPIPath, formdata)
        .then(function(response) {
          vm.results.push({
            file: file_name,
            upload: response.data.result
          });
        })
        .catch(function(error) {
          console.log(error);
        }).finally(() => (vm.busy = false));
    },
    uploadDocument(endpoint, data) {
      return this.postMultipart(endpoint, data);
    },
  },
  
};
</script>
